export const selectGlobalFilters = (state: any) => state.get('globalFilters');
export const selectsearchableLocations = (state: any) => state.getIn(['globalFilters', 'searchableLocations']);

export const selectLocationsToAccess = (state: any) => {
  return (
    state.getIn(['globalFilters', 'locationsToAccess'])?.toArray().map((v: any) => v.toString()) || []
  );
};

export const selectSelectedLocationsSlug = (state: any) => {
  return {
    businessUnit: state.getIn(['globalFilters', 'businessUnit', 'slug']),
    zone: state.getIn(['globalFilters', 'zone', 'slug']),
    subzone: state.getIn(['globalFilters', 'subzone', 'slug']),
    location: state.getIn(['globalFilters', 'location', 'slug']),
    cluster: state.getIn(['globalFilters', 'cluster', 'slug']),
  };
};

export const selectSelectedLocation = (state: any) => {
  return {
    locationName: state.getIn(['globalFilters', 'location', 'name']),
    locationSlug: state.getIn(['globalFilters', 'location', 'slug']),
    timezoneDomain: state.getIn(['globalFilters', 'location', 'timezoneDomain']),
  };
};

export const selectSelectedBusinessUnit = (state: any) => {
  return {
    name: state.getIn(['globalFilters', 'businessUnit', 'name']),
    slug: state.getIn(['globalFilters', 'businessUnit', 'slug']),
    id: state.getIn(['globalFilters', 'businessUnit', 'id']),
  };
};

export const selectAllClusters = (state: any) => {
  return state.getIn(['globalFilters', 'allClusters'])?.toJS();
};

export const selectUserAccesses = (state: any) => {
  return state.getIn(['globalFilters', 'analyticsFilters', 'businessUnits'])?.toJS();
};
